import { render } from "./TemperatureTabletFormComponent.vue?vue&type=template&id=6b7a23a7"
import script from "./TemperatureTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./TemperatureTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__